<template>
  <b-container class="container-rda sidebar">
    <b-row class="height">
      <sidebar-admin />
      <b-col class="content">
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <Breadcrumb :breadcrumb="breadcrumb" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <h2 class="purple bold">Usuários</h2>
          </b-col>
          <b-col class="text-right">
            <b-button
              class="btn large blue"
              :to="{
                name: 'novosusuario',
              }"
              >Novo usuário</b-button
            >
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Função">
              <b-form-select
                class=""
                size="sm"
                v-model="filters.role"
                :options="roles"
                @change="updateFilter"
              >
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col align="end">
            <b-form-group label="Buscar colaborador">
              <b-input-group-prepend>
                <b-form-input
                  type="search"
                  size="sm"
                  placeholder="Digite aqui"
                  v-model="filters.name"
                  v-debounce:1s="updateFilter"
                />
              </b-input-group-prepend>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-h="center" v-if="loading">
          <b-col cols="12" class="text-center mt-5 mb-5">
            <b-spinner
              style="color: #b23066"
              label="Carregando usuários..."
            ></b-spinner>
            <p class="mt-3 text-muted">Carregando usuários...</p>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="!loading">
          <b-col>
            <b-container fluid>
              <b-row class="header-list-teacher" v-if="users.length > 0">
                <b-col md="3" align="center">
                  <p class="bold">Nome</p>
                </b-col>
                <b-col md="3" align="center">
                  <p class="bold">Função</p>
                </b-col>
                <b-col md="2" align="center">
                  <p class="bold">Editar senha</p>
                </b-col>

                <b-col md="2" align="center">
                  <p class="bold">Editar</p>
                </b-col>
                <b-col md="2" align="center">
                  <p class="bold">Excluir</p>
                </b-col>
              </b-row>
            </b-container>

            <b-container fluid>
              <b-row
                align-v="center"
                class="list-teacher"
                v-for="item in users"
                v-bind:key="item.id"
              >
                <b-col md="3" align="center">
                  <p>{{ item.name }}</p>
                </b-col>
                <b-col md="3" align="center">
                  <p>{{ getRoleDescription(item.Roles[0].id) }}</p>
                </b-col>
                <b-col md="2" align="center">
                  <a
                    @click="() => setUserPassword(item)"
                    v-b-modal.edit-password
                  >
                    <LockIcon />
                  </a>
                </b-col>
                <b-col md="2" align="center">
                  <router-link
                    :to="{
                      name: 'perfil-usuario',
                      params: {
                        id: item.id,
                      },
                    }"
                  >
                    <EditIcon />
                  </router-link>
                </b-col>
                <b-col md="2" align="center">
                  <a @click="() => DeleteUser(item.id)">
                    <DeleteIcon />
                  </a>
                </b-col>
              </b-row>

              <b-row v-if="users.length === 0" class="mt-4">
                <b-col class="text-center">
                  <p class="text-muted">Nenhum usuário encontrado.</p>
                </b-col>
              </b-row>
            </b-container>

            <b-row class="align-center mt-4" v-if="count > perPage">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="count"
                aria-controls="usersList"
                last-text
                first-text
              >
                <template #prev-text>
                  <LeftArrowIcon class="left" />
                </template>
                <template #next-text>
                  <LeftArrowIcon />
                </template>
              </b-pagination>
            </b-row>
          </b-col>
        </b-row>
        <UserEditPassword :key="userToPassword" :userToEdit="userToPassword" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HttpRda from "../../../http-rda";
import EditIcon from "@/components/svg/EditIcon.vue";
import DeleteIcon from "@/components/svg/DeleteIcon.vue";
import LockIcon from "@/components/svg/LockIcon.vue";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import UserEditPassword from "@/components/modals/UserEditPassword.vue";
import SidebarAdmin from "../../../components/SidebarAdmin.vue";

export default {
  components: {
    DeleteIcon,
    LockIcon,
    EditIcon,
    LeftArrowIcon,
    UserEditPassword,
    SidebarAdmin,
  },

  data() {
    const query = this.$route.query;

    return {
      name: "usuarios",
      loading: false,
      filters: {
        role: null,
        name: query.name || null,
      },
      userToPassword: {},
      breadcrumb: [
        {
          text: "Secretaria",
          href: "/secretaria",
        },
        {
          text: "Usuários",
          href: "/secretaria/usuarios",
        },
      ],
      users: [],
      roles: [],
      currentPage: query.page ? Number(query.page) : 1,
      count: 0,
      perPage: 10,
    };
  },

  methods: {
    getRoleDescription(roleId) {
      return this.roles.find((role) => role.value === roleId)?.text || "---";
    },

    DeleteUser(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await HttpRda.delete(`/collaborator/${id}`)
              .then(() => {
                this.$swal.fire({
                  title: "Sucesso!",
                  text: "Usuário excluido com sucesso!",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getUser();
              })
              .catch(() => {
                this.$swal.fire({
                  title: "Erro!",
                  text: "Não foi possível excluir o usuário!",
                  icon: "error",
                  showConfirmButton: false,
                  timer: 1500,
                });
              });
          }
        });
    },

    setUserPassword(item) {
      this.userToPassword = item;
    },

    updateFilter() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }

      this.getUser();
    },

    updateQuery() {
      const query = {
        role: this.roles.find((role) => role.value === this.filters.role)?.name,
        name: this.filters.name,
        page: this.currentPage,
      };

      Object.keys(query).forEach(
        (key) => (query[key] == null || query[key] === "") && delete query[key]
      );

      this.$router.replace({ query }).catch(() => {});
    },

    async getUser() {
      this.loading = true;
      this.updateQuery();

      const params = {
        limit: this.perPage,
        page: this.currentPage,
      };

      if (this.filters.role) {
        params.role = this.filters.role;
      }

      if (this.filters.name && this.filters.name !== "") {
        params.name = this.filters.name;
      }

      try {
        await HttpRda.get("/collaborator", { params }).then((response) => {
          this.users = response.data.users;
          this.count = response.data.pagination.total;
          this.loading = false;
        });
      } catch (e) {
        this.loading = false;
      }
    },

    async getRoles() {
      await HttpRda.get("/roles-select").then((response) => {
        this.roles = response.data.roles;
        this.roles.unshift({ value: null, text: "Todas" });
      });
    },
  },

  async created() {
    await this.getRoles();

    const roleFromQuery = this.roles.find(
      (role) => role.name === this.$route.query.role
    );
    this.filters.role = roleFromQuery?.value ?? null;

    this.getUser();
  },

  watch: {
    currentPage() {
      this.getUser();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
.align-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left {
  transform: rotate(0deg);
}
</style>
